/** Supabase Storage buckets: where every file lives until its row flips. */
export const SOURCE_BUCKETS = ['models', 'audio', 'images', 'avatars'] as const;
export type SourceBucket = (typeof SOURCE_BUCKETS)[number];

/** R2 buckets. `images` and `avatars` share `assets`; a custom domain serves one bucket. */
export const R2_BUCKETS = {
  models: 't3k-models',
  audio: 't3k-audio',
  assets: 't3k-assets',
  staging: 't3k-staging',
} as const;
export type R2Bucket = keyof typeof R2_BUCKETS;

/** Stored as `r2://<bucket>/<key>`: unfetchable, so a reader we missed fails loudly. */
export const PRIVATE_R2_BUCKETS = ['models', 'audio'] as const;
export type PrivateR2Bucket = (typeof PRIVATE_R2_BUCKETS)[number];

export const R2_REF_SCHEME = 'r2://';
/** Serves `t3k-models` behind the WAF token rule. */
export const FILES_ORIGIN = 'https://files.tone3000.com';
/** Serves `t3k-assets`, public. */
export const ASSETS_ORIGIN = 'https://assets.tone3000.com';

export const LEGACY_PUBLIC_SEGMENT = '/storage/v1/object/public/';
/** The project host, which predates the api.tone3000.com custom domain. */
export const LEGACY_PROJECT_ORIGIN = 'https://gzybiuopxkdxbytnojds.supabase.co';

export const isSourceBucket = (b: string): b is SourceBucket => (SOURCE_BUCKETS as readonly string[]).includes(b);
export const isPrivateR2Bucket = (b: string): b is PrivateR2Bucket =>
  (PRIVATE_R2_BUCKETS as readonly string[]).includes(b);

/** Where a source bucket's objects live in R2: `images` and `avatars` share `assets`. */
export const r2BucketFor = (bucket: SourceBucket): 'models' | 'audio' | 'assets' =>
  bucket === 'images' || bucket === 'avatars' ? 'assets' : bucket;
